module.exports = __webpack_public_path__ + "img/logo-white.61690520.png";